import React, {useMemo} from "react";
import { useAppContext } from "../../helpers/account-context";
import DropDown from "./DropDown";

const RegionsDropdown = (props) => {
  const { filters, onChangeFilters } = props;
  // https://codepen.io/smithsuth/pen/VvYzZP
  const {
    initedData: { enabledRegions },
    getLocale,
    regions,
  } = useAppContext();

  const enabledCountries =
    enabledRegions.indexOf("all") >= 0 ||
    enabledRegions.indexOf("countries") >= 0;
  const enabledStates =
    enabledRegions.indexOf("all") >= 0 || enabledRegions.indexOf("provinces") >= 0;
  const enabledCities =
    enabledRegions.indexOf("all") >= 0 || enabledRegions.indexOf("cities") >= 0;

  const countries = useMemo(() => {
    return [...new Set(regions.map((item) => item.country))];
  }, [regions]);

  const countriesOptions = useMemo(() => {
    return countries.map((rgn) => ({ label: rgn, value: rgn }));
  }, [countries]);

  const provRegions = useMemo(() => {
    return regions.filter(
      (item) =>
        !filters.country ||
        filters.country.toLowerCase() === item.country.toLowerCase())
  }, [regions, filters.country]);

  const provinces = useMemo(() => {
    return [...new Set(provRegions.map((item) => item.state))];
  }, [provRegions]);

  const provincesOptions = useMemo(() => {
    return provinces.map((rgn) => ({ label: rgn, value: rgn }));
  }, [provinces]);
  const cityRegions = useMemo(() => {
    return regions.filter(
      (item) =>
        !filters.country ||
        !filters.province ||
        (filters.country.toLowerCase() === item.country.toLowerCase() &&
          filters.province.toLowerCase() === item.state.toLowerCase())
    )
  }, [regions, filters.country, filters.province]);

  const cities = useMemo(() => {
    return [...new Set(cityRegions.map((item) => item.city))];
  }, [cityRegions]);

  const citiesOptions = useMemo(() => {
    return cities.map((rgn) => ({ label: rgn, value: rgn }));
  }, [cities]);

  const handleChangeCountry = (e) => {
    const country = e && e.length > 0 ? e[0] : "";
    onChangeFilters({
      ...filters,
      country,
      province: null,
    });
  };

  const handleChangeProvince = (e) => {
    const province = e && e.length > 0 ? e[0] : "";
    onChangeFilters({
      ...filters,
      province,
      city: null,
    });
  };

  const handleChangeCity = (e) => {
    const city = e && e.length > 0 ? e[0] : "";
    onChangeFilters({
      ...filters,
      city,
    });
  };

  return (
    <div className="cbmap-region-dropdown">
      {
        enabledCountries && <DropDown
        className="cbmap-dropdown-country"
        title={`${filters.country ? filters.country : getLocale("select_country")}`}
        items={countriesOptions}
        selectedItems={filters.country ? [filters.country] : []}
        isMulti={false}
        onChange={handleChangeCountry}
      />
      }
      
      {
        enabledStates && <DropDown
        className="cbmap-dropdown-province"
        title={`${
          filters.province ? filters.province : getLocale("select_province")
        }`}
        items={provincesOptions}
        selectedItems={filters.province ? [filters.province] : []}
        isMulti={false}
        onChange={handleChangeProvince}
      />
      }

      {
        enabledCities && <DropDown
        className="cbmap-dropdown-city"
        title={`${filters.city ? filters.city : getLocale("select_city")}`}
        items={citiesOptions}
        selectedItems={filters.city ? [filters.city] : []}
        isMulti={false}
        onChange={handleChangeCity}
      />
      }

      
    </div>
  );
};

export default RegionsDropdown;
